export default {
    'ERROR-GET-HELPER-RELATION-DETAILS': {
        'NO-HELPEE-ID-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Cette relation n'est plus accessible",
                en: "This relation is not accessible anymore",
            },
            redirectPath: '/',
        },
        'NO-RELATION-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Cette relation n'est plus accessible",
                en: "This relation is not accessible anymore",
            },
            redirectPath: '/relations-not-found',
        },
        'RELATION-ARCHIVED-AND-REMATCH-ASKED': {
            actionType: 'redirect',
            message: {
                fr: "Cette relation n'est plus accessible",
                en: "This relation is not accessible anymore",
            },
            redirectPath: '/',
        },
        'NO-CAMPAIGN-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Cette relation n'est plus accessible",
                en: "This relation is not accessible anymore",
            },
            redirectPath: '/',
        },
        'NO-HELPEE-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Cette relation n'est plus accessible",
                en: "This relation is not accessible anymore",
            },
            redirectPath: '/',
        },
        'NO-RELATION-MOMENT-FOUND': {
            actionType: 'redirect',
            message: {
                fr: "Cette relation n'est plus accessible",
                en: "This relation is not accessible anymore",
            },
            redirectPath: '/',
        },
    },
};
